import Text from "component/design-system/typography/Text";
import { useTranslation } from "next-i18next";
import openLiveChat from "util/chat-widget/open-live-chat";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import PAButton from "../../component/design-system/buttons/PAButton";
import styles from "./contact-us.module.scss";

function ContactUsVertical() {
  const { t } = useTranslation("static-pages");

  function handleChat() {
    openLiveChat();
  }

  return (
    <div className={styles.container_vertical}>

      <Text>{t("Contact Customer Service")}</Text>

      <p>{t("expert_help")}</p>

      <div
        className="text-center d-flex flex-column button-container"
        style={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-around",
        }}
      >

        <div className={styles.each_section}>

          <img alt="chat" src={getRelativeImagePath("/images/public/chat.svg")} />

          <span>
            {t("Live Chat")}
            {" "}
            24/5
          </span>

          <PAButton
            type="button"
            style={{ marginTop: "calc(1 * var(--safari-root-font, 10px))", width: "80%" }}
            onClick={() => handleChat()}
          >
            {" "}
            {t("Chat Now")}
          </PAButton>
        </div>
      </div>
    </div>
  );
}

export default ContactUsVertical;
